<section class="calendar-lab">
  <header class="calendar-lab__header">
    <h1>Laboratório do app-calendar</h1>
    <p>Página de teste para acompanhar eventos, mudanças de valor e possíveis loops.</p>
    <div class="calendar-lab__actions">
      <button appButton buttonType="outline" label="Limpar logs" (click)="clearLogs()"></button>
      <button
        appButton
        buttonType="primary"
        label="Resetar estados"
        (click)="resetAllStates()"></button>
    </div>
  </header>

  <section class="calendar-lab__group calendar-lab__group--ngmodel">
    <h2 class="calendar-lab__group-title">Cenários com ngModel</h2>
    <div class="calendar-lab__grid">
      <article class="calendar-lab__card">
        <h3>1) Data simples (ngModel)</h3>
        <app-calendar
          label="Data (ngModel)"
          placeholder="DD/MM/AAAA"
          [(ngModel)]="ngModelSingleValue"
          (ngModelChange)="onNgModelChange('ngModel-single', $event)"
          (sendCalendarValue)="onOutput('ngModel-single.sendCalendarValue', $event)"></app-calendar>
        <pre>{{ ngModelSingleValue | json }}</pre>
        <pre class="calendar-lab__card-log">{{ getScenarioLogText('ngModel-single') }}</pre>
      </article>

      <article class="calendar-lab__card">
        <h3>2) Mês/Ano (ngModel)</h3>
        <app-calendar
          label="Competência (MM/AAAA)"
          [displayFormat]="'month-year'"
          [view]="'month'"
          [bindAsSingle]="true"
          [(ngModel)]="ngModelMonthYearValue"
          (ngModelChange)="onNgModelChange('ngModel-month-year', $event)"
          (sendCalendarValue)="onOutput('ngModel-month-year.sendCalendarValue', $event)">
        </app-calendar>
        <pre>{{ ngModelMonthYearValue | json }}</pre>
        <pre class="calendar-lab__card-log">{{ getScenarioLogText('ngModel-month-year') }}</pre>
      </article>

      <article class="calendar-lab__card">
        <h3>3) Range (ngModel)</h3>
        <app-calendar
          label="Período (range)"
          [selectionMode]="'range'"
          [(ngModel)]="ngModelRangeValue"
          (ngModelChange)="onNgModelChange('ngModel-range', $event)"
          (sendCalendarValue)="onOutput('ngModel-range.sendCalendarValue', $event)">
        </app-calendar>
        <pre>{{ ngModelRangeValue | json }}</pre>
        <pre class="calendar-lab__card-log">{{ getScenarioLogText('ngModel-range') }}</pre>
      </article>

      <article class="calendar-lab__card">
        <h3>4) Time only (ngModel)</h3>
        <app-calendar
          label="Horário (timeOnly)"
          [timeOnly]="true"
          [showTime]="true"
          [useMask]="false"
          [placeholder]="'HH:mm'"
          [(ngModel)]="ngModelTimeOnlyValue"
          (ngModelChange)="onNgModelChange('ngModel-time-only', $event)"
          (sendCalendarValue)="onOutput('ngModel-time-only.sendCalendarValue', $event)">
        </app-calendar>
        <pre>{{ ngModelTimeOnlyValue | json }}</pre>
        <pre class="calendar-lab__card-log">{{ getScenarioLogText('ngModel-time-only') }}</pre>
      </article>

      <article class="calendar-lab__card">
        <h3>5) Valor inicial + limites com timeout (ngModel)</h3>
        <app-calendar
          label="Carregamento tardio de limites"
          [minDate]="delayedMinDate"
          [maxDate]="delayedMaxDate"
          [(ngModel)]="ngModelDelayedValue"
          (ngModelChange)="onNgModelChange('ngModel-delayed', $event)"
          (sendCalendarValue)="onOutput('ngModel-delayed.sendCalendarValue', $event)">
        </app-calendar>
        <pre>{{
          {
            loading: delayedDateLoading,
            minDate: delayedMinDate | date: 'yyyy-MM-dd',
            maxDate: delayedMaxDate | date: 'yyyy-MM-dd',
            value: ngModelDelayedValue,
          } | json
        }}</pre>
        <pre class="calendar-lab__card-log">{{ getScenarioLogText('ngModel-delayed') }}</pre>
      </article>
    </div>
  </section>

  <section class="calendar-lab__group calendar-lab__group--form">
    <h2 class="calendar-lab__group-title">Cenários com FormGroup</h2>
    <div class="calendar-lab__grid">
      <article class="calendar-lab__card">
        <h3>6) FormGroup simples</h3>
        <form [formGroup]="form">
          <app-calendar
            label="Data (FormGroup)"
            [formGroup]="form"
            controlName="single"
            [minDate]="minDate"
            [maxDate]="maxDate"
            (sendCalendarValue)="onOutput('form-single.sendCalendarValue', $event)">
          </app-calendar>
        </form>
        <pre>{{ form.get('single')?.value | json }}</pre>
        <pre class="calendar-lab__card-log">{{ getScenarioLogText('form-single') }}</pre>
      </article>

      <article class="calendar-lab__card">
        <h3>7) FormGroup range</h3>
        <form [formGroup]="form">
          <app-calendar
            label="Período (FormGroup range)"
            [selectionMode]="'range'"
            [formGroup]="form"
            controlName="range"
            (sendCalendarValue)="onOutput('form-range.sendCalendarValue', $event)">
          </app-calendar>
        </form>
        <pre>{{ form.get('range')?.value | json }}</pre>
        <pre class="calendar-lab__card-log">{{ getScenarioLogText('form-range') }}</pre>
      </article>

      <article class="calendar-lab__card">
        <h3>8) FormGroup mês/ano</h3>
        <form [formGroup]="form">
          <app-calendar
            label="Competência (FormGroup)"
            [displayFormat]="'month-year'"
            [view]="'month'"
            [bindAsSingle]="true"
            [formGroup]="form"
            controlName="monthYear"
            (sendCalendarValue)="onOutput('form-month-year.sendCalendarValue', $event)">
          </app-calendar>
        </form>
        <pre>{{ form.get('monthYear')?.value | json }}</pre>
        <pre class="calendar-lab__card-log">{{ getScenarioLogText('form-month-year') }}</pre>
      </article>

      <article class="calendar-lab__card">
        <h3>9) FormGroup com bloqueio de fim de semana/feriado</h3>
        <form [formGroup]="form">
          <app-calendar
            label="Somente dias úteis"
            [disableWeekendsAndHolidays]="true"
            [formGroup]="form"
            controlName="weekendHoliday"
            (sendCalendarValue)="onOutput('form-weekend-holiday.sendCalendarValue', $event)">
          </app-calendar>
        </form>
        <pre>{{ form.get('weekendHoliday')?.value | json }}</pre>
        <pre class="calendar-lab__card-log">{{ getScenarioLogText('form-weekend-holiday') }}</pre>
      </article>

      <article class="calendar-lab__card">
        <h3>10) FormGroup com appAutoFormGroup (sem [formGroup] no app-calendar)</h3>
        <form [formGroup]="form" appAutoFormGroup>
          <app-calendar
            label="Data (auto form group)"
            controlName="autoSingle"
            (sendCalendarValue)="onOutput('form-auto.sendCalendarValue', $event)">
          </app-calendar>
        </form>
        <pre>{{ form.get('autoSingle')?.value | json }}</pre>
        <pre class="calendar-lab__card-log">{{ getScenarioLogText('form-auto') }}</pre>
      </article>
    </div>
  </section>

  <section class="calendar-lab__logs">
    <h2>Log de eventos</h2>
    <pre *ngIf="logs.length === 0">Sem eventos ainda.</pre>
    <pre *ngIf="logs.length > 0">{{ logs.join('\n') }}</pre>
  </section>
</section>
